/*
  Funnel stamping outside the Flow landers.

  When any add-to-cart finishes (theme form, custom AJAX helper, Octane quiz,
  cart drawer), read the cart, find the line that was just added, and write the
  surface, plan and variant onto the cart as attributes. Every order then says
  where it was added to cart and whether it started on subscription. Same
  attribute names as the lander stamping in section-lp-feature-product.js.

  It watches finished network requests instead of wrapping fetch or
  XMLHttpRequest: other scripts on the site already wrap both, one replaces
  XMLHttpRequest outright, and none of that should decide whether an order gets
  stamped. It never touches the add-to-cart request itself.

  Rules:
  - The Flow landers stamp their own orders, so nothing runs on those pages.
  - Adds made by the free-gift app (_easygift) and zero-priced lines are ignored,
    so a free Vitamin D never overwrites the plan of the product she chose.
  - If the add contained a subscription line, the stamp is flex.
  - Last add-to-cart wins.
*/
(function () {
  if (window.__guudFunnelStamp) return;
  window.__guudFunnelStamp = true;
  if (!window.fetch || !window.PerformanceObserver) return;

  var ENTRY_KEY = 'guudFunnelEntry';
  var LANDING_KEY = 'guudFunnelLanding';

  function readContext() {
    try {
      var el = document.getElementById('guud-funnel-context');
      return el ? JSON.parse(el.textContent || '{}') || {} : {};
    } catch (e) {
      return {};
    }
  }

  function isQuizPage(ctx) {
    return ctx.type === 'page' && /quiz|find-your-guud/.test(ctx.page || '');
  }

  function funnelName(ctx) {
    if (isQuizPage(ctx)) return 'quiz';
    if (ctx.type === 'product' && ctx.product) return 'pdp-' + ctx.product;
    if (ctx.type === 'collection' && ctx.collection) return 'collection-' + ctx.collection;
    if (ctx.type === 'page' && ctx.page) return 'page-' + ctx.page;
    if (ctx.type === 'index') return 'home';
    return ctx.type || 'unknown';
  }

  function storageGet(key) {
    try { return window.sessionStorage.getItem(key) || ''; } catch (e) { return ''; }
  }

  function storageSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) {}
  }

  var context = readContext();
  if (!storageGet(LANDING_KEY)) storageSet(LANDING_KEY, window.location.pathname);
  if (isQuizPage(context)) storageSet(ENTRY_KEY, 'quiz');

  function isLanderPage() {
    return !!document.querySelector('[data-lp-fp-root]');
  }

  function cartUrl() {
    return (window.routes && window.routes.cartUrl) || '/cart';
  }

  function getCart() {
    return window.fetch(cartUrl() + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) { return res.json(); });
  }

  function quantities(cart) {
    var map = {};
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      map[item.key] = item.quantity;
    });
    return map;
  }

  var snapshot = {};
  var queue = getCart().then(function (cart) { snapshot = quantities(cart); }).catch(function () {});

  function writeStamp(line, isFlex) {
    var plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
    return window.fetch(cartUrl() + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          funnel: funnelName(context),
          funnel_template: String(context.template || ''),
          funnel_plan: isFlex ? 'flex' : 'onetime',
          funnel_tier: '',
          funnel_kit: '',
          funnel_variant_id: String(line.variant_id || ''),
          funnel_gifts: '',
          funnel_selling_plan: plan ? String(plan.id) : '',
          funnel_entry: storageGet(ENTRY_KEY),
          funnel_landing: storageGet(LANDING_KEY)
        }
      })
    });
  }

  function onCartAdd() {
    queue = queue.then(function () {
      if (isLanderPage()) return;
      return getCart().then(function (cart) {
        var before = snapshot;
        snapshot = quantities(cart);
        var added = (cart.items || []).filter(function (item) {
          return item.quantity > (before[item.key] || 0) && item.final_line_price > 0;
        });
        if (!added.length) return;
        var subscriptionLines = added.filter(function (item) {
          return !!item.selling_plan_allocation;
        });
        var line = subscriptionLines[0] || added[0];
        return writeStamp(line, subscriptionLines.length > 0);
      });
    }).catch(function () {});
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(url) && !/_easygift/.test(url);
  }

  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (entry.initiatorType !== 'fetch' && entry.initiatorType !== 'xmlhttprequest') return;
        if (isCartAddUrl(entry.name)) onCartAdd();
      });
    }).observe({ type: 'resource', buffered: false });
  } catch (e) {}
})();
